var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.lpi{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "lpi",
    d: "M4.08,10.93H3.27v-7.6h0.81V10.93z M8.29,11.03c-0.35,0-0.67-0.06-0.96-0.19c-0.29-0.13-0.53-0.33-0.72-0.59 H6.55c0.04,0.31,0.06,0.61,0.06,0.89v2.2H5.8V5.58h0.66l0.11,0.73h0.04c0.21-0.29,0.45-0.5,0.73-0.63s0.59-0.2,0.95-0.2 c0.71,0,1.26,0.24,1.64,0.73c0.39,0.49,0.58,1.17,0.58,2.04c0,0.88-0.2,1.56-0.59,2.05C9.53,10.78,8.98,11.03,8.29,11.03z  M8.17,6.17c-0.55,0-0.94,0.15-1.19,0.45S6.61,7.41,6.61,8.07v0.18c0,0.75,0.12,1.29,0.38,1.61c0.25,0.32,0.65,0.49,1.21,0.49 c0.46,0,0.82-0.19,1.09-0.56C9.54,9.41,9.67,8.9,9.67,8.24c0-0.67-0.13-1.18-0.39-1.54C9.01,6.35,8.64,6.17,8.17,6.17z M11.86,4.13 c0-0.19,0.05-0.32,0.14-0.41c0.09-0.09,0.21-0.13,0.34-0.13s0.24,0.04,0.34,0.13s0.14,0.22,0.14,0.41s-0.05,0.32-0.14,0.41 c-0.09,0.09-0.21,0.13-0.34,0.13c-0.14,0-0.25-0.04-0.34-0.13C11.9,4.45,11.86,4.31,11.86,4.13z M12.73,10.93h-0.81V5.58h0.81V10.93 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLpi);
export default __webpack_public_path__ + "static/media/icon_lpi.3ded12b2ef7359ebcf9b1d23fc272f6c.svg";
export { ForwardRef as ReactComponent };